export const ROLE_USER = 'ROLE_USER'
export const ROLE_TENANT_ADMIN = 'ROLE_TENANT_ADMIN'
export const ROLE_SUPER_ADMIN = 'ROLE_SUPER_ADMIN'
